module.exports = __webpack_public_path__ + "img/esc_3_act_2.e5f61796.png";